import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FullWithModal from '../../components/common/Modal/FullWidthModal';
import PaymentTerminall from '@components/paymentTerminalCheckDetail/indexRevamp';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import Loader from '@components/common/Loader/newLoaderModal';
import Search from '@components/common/search';
import OptionMenus from '@components/common/OptionsMenus/indexCopy';
import Modal from '@components/common/Modal';
import { setSeat, setPaymentCheck, setSyncData } from '@reducers/orders';
import {
  syncCheck,
  printing,
  syncCheckForPayment,
  syncForPayment,
} from '@reducers/storeChecks';
import {
  setNotification,
  setPrintNotification,
  setErrorPopUp,
} from '@reducers/notification';
import {
  openEmployeeCheck,
  logout,
  setInActivityStatus,
} from '@reducers/oauth';
import { flowType } from '@utility/userInfo';
import { getObjectValue } from '@utility/utills';
import { createFilter } from '../../utility/helperFunction';
import { tableOperation } from '@utility';
import EventEmitter from '@utility/eventSubscribers';
import { APP_CONFIG } from '@constants';
import { LABEL } from '../../veriables';
import { ReactComponent as SearchDetailsTwo } from '@assets/images/SearchDetailsTwo.svg';
import { ReactComponent as SignOutIcon } from '@assets/images/sign_out.svg';
import { ReactComponent as Help } from '@assets/images/help2.svg';
import { ReactComponent as Sorting } from '@assets/images/sorting.svg';
import { ReactComponent as MoreInfo } from '@assets/images/moreInfo.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import dollar from '@assets/images/dollar.svg';
import Alert from '@assets/images/Alert.png';
import cn from 'classnames';
import style from './index.module.scss';
import { toggleTheme } from '@reducers/theme';

const PaymentTerminal = props => {
  const SORT_ASC = 'asc';
  const SORT_DESC = 'desc';
  // props Destructuring
  const serverAppTheme = props.serverAppTheme;
  // State Management
  const [checks, setChecks] = useState([]);
  const [sortKey, setSortKey] = useState('stationId');
  const [isSearch, setIsSearch] = useState(false);
  const [sortBy, setSortBy] = useState(SORT_ASC);
  const [search, setSearch] = useState('');
  const [moreModel, setMoreModel] = useState(false);
  const [printModel, setPrintModel] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [selectedCheck, setSelectedCheck] = useState();
  const [openKeyboard, setOpenKeyboard] = useState(false);
  const [isLandScape, setIsLandScape] = useState(
    window.innerWidth > window.innerHeight
  );
  const [payLoading, setPayLoading] = useState(false);
  const [payLoadingData, setPayLoadingData] = useState('');
  const [errorpayLoading, setErrorpayLoading] = useState(false);
  const payRetryData = {
    data: {},
    currentPage: 0,
  };
  const suppressZeroDollarChecks = getObjectValue(
    () => props.auth.serverAppFeatures.suppressZeroDollarChecks,
    false
  );
  const seats = window.sessionStorage.getItem('seat')
    ? JSON.parse(window.sessionStorage.getItem('seat')).seats
    : null;

  //React Hooks
  const getTheme = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme
  );
  // React Hooks
  useEffect(() => {
    toggleTheme(getTheme);
  }, []);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
    }
    window.sessionStorage.removeItem('authResponse');
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsLandScape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (search == '' || search == null) {
      setChecks(tableList);
    } else {
      searchUpdated(search);
      searchUpdated(search);
    }
  }, [props.tableData]);

  // Methods

  const inLineStyle = useMemo(() => {
    const checkListStyle = showMoreOption => {
      return {
        background: showMoreOption
          ? serverAppTheme?.selectedCheck_bg
          : serverAppTheme?.tile_bg,
        height: showMoreOption ? (isLandScape ? '23%' : '10.5%') : '5.3%',
        color: serverAppTheme?.primary_text,
      };
    };
    const moreButOpen = item => {
      return {
        background:
          item.id === 3
            ? serverAppTheme?.menu_btn_disable_bg2
            : item.key === 'pay'
            ? '#29A52B'
            : serverAppTheme?.primaryBtn,
      };
    };
    const moreButParent = {
      background: serverAppTheme?.menu_btn_bg,
      height: '2.813rem',
    };
    const icon = { background: serverAppTheme?.iconcolor_bg_box };
    const moreButton = showMoreOption => {
      return {
        transform: showMoreOption && 'rotate(90deg)',
        background: showMoreOption
          ? serverAppTheme?.menu_btn_bg
          : serverAppTheme?.tile_bg,
      };
    };
    const tablePopUp = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      pointerEvents: 'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      backgroundClip: 'padding-box',
      height: '100%',
      borderRadius: '16px',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };
    const selectedSeatsStyle = {
      color: selectedSeats.includes('table')
        ? '#000'
        : serverAppTheme?.primary_text,
      width: isLandScape ? '96px' : '148px',
      height: '44px',
      border: serverAppTheme?.popupBorder,
      background: selectedSeats.includes('table')
        ? serverAppTheme?.selected
        : serverAppTheme?.OFF_Premise_Btn,
    };
    const unSelectedSeatsStyle = e => {
      return {
        width: isLandScape ? '96px' : '148px',
        height: '44px',
        color: selectedSeats.includes(e.id)
          ? '#000'
          : serverAppTheme?.primary_text,
        border: selectedSeats.includes(e.id)
          ? 'none'
          : serverAppTheme?.popupBorder,
        background: selectedSeats.includes(e.id)
          ? serverAppTheme?.selected
          : serverAppTheme?.unselected,
      };
    };
    const cancelButton = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
      borderRadius: '8px',
    };
    const printButton = {
      backgroundColor:
        selectedSeats.length === 0
          ? serverAppTheme?.secondary_btn_disable
          : serverAppTheme?.secondaryBtn,
      color:
        selectedSeats.length === 0
          ? serverAppTheme?.secondary_btn_disable_text
          : serverAppTheme?.btn_font_color,
      borderRadius: '8px',
    };
    const modalStyle = {
      backgroundColor: serverAppTheme.popUp_bg,
      borderRadius: '16px',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
    };
    const parentContainerColor = {
      color: serverAppTheme?.primary_text,
      width: '486px',
    };
    const printerName = { color: serverAppTheme?.primary_text };

    return {
      checkListStyle,
      moreButOpen,
      moreButParent,
      icon,
      moreButton,
      tablePopUp,
      selectedSeatsStyle,
      unSelectedSeatsStyle,
      cancelButton,
      printButton,
      modalStyle,
      parentContainerColor,
      printerName,
    };
  }, [serverAppTheme, isLandScape, selectedSeats]);
  const toToStage = () => {
    setPayLoading(true);
    setPayLoadingData('Synchronizing check');
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(userInfo.id),
      storeId: deviceInfo.storeId,
      checkHeaderId: props.check.id,
      totalAmount: props.check.totalAmount,
      unpaidAmount: Number(props.check.unpaidAmount),
      paidAmount: props.check.paidAmount,
    };
    props
      .syncCheckForPayment(dataToSend)
      .then(res => {
        const syncedCheck = res;
        props.setPaymentCheck({ ...syncedCheck }).then(() => {
          props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/stage`);
        });
      })
      .catch(err => {
        setPayLoading(false);
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const navigateToPaymentScreen = e => {
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(userInfo.id),
      storeId: deviceInfo.storeId,
      checkHeaderId: e.id,
      totalAmount: e.totalAmount,
      unpaidAmount: Number(e.unpaidAmount),
      paidAmount: e.paidAmount,
    };
    props
      .syncForPayment(dataToSend)
      .then(res => {
        const syncedCheck = res.check;
        let updatedData = {
          ...syncedCheck,
          control: res?.control,
          checkHeaderId: res?.checkHeaderId,
          storeId: res?.storeId,
          giftCard: res?.giftCard,
          offer: res?.offer,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        };
        props.setSeat(updatedData);
        props.setSyncData(updatedData);
        props.setPaymentCheck(updatedData).then(() => {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${e?.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
          });
        });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const goToDetailsPage = e => {
    props.setSeat(e).then(() => {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/details`);
    });
  };

  const tableHead = [
    {
      key: 'stationId',
      name: LABEL().TABLE,
    },
    {
      key: 'number',
      name: 'Check#',
    },

    {
      key: 'paidAmount',
      name: LABEL().PAID,
    },
    {
      key: 'unpaidAmount',
      name: LABEL().DUE,
    },
    {
      key: 'totalAmount',
      name: LABEL().TOTAL,
    },
    {
      key: 'more',
      name: '',
    },
  ];

  const headerData = [
    {
      key: 'stationId',
    },
    {
      key: 'number',
    },
  ];

  const syncCheck = () => {
    let checkData = JSON.parse(window.sessionStorage.getItem('seat'));
    props.syncCheck(props.auth.id, checkData.id).catch(err => {
      props.setErrorPopUp({
        res: err.message,
      });
    });
  };

  const printModelPopup = () => {
    setPrintModel(true);
  };

  const onCloseModel = () => {
    setPrintModel(false);
  };

  const viewDetailsPopup = () => {
    setViewDetails(true);
  };

  const viewDetailsOnClose = () => {
    setViewDetails(false);
  };
  const addRemoveSeats = node => {
    if (selectedSeats.indexOf(node) === -1 && selectedSeats.includes('table')) {
      setSelectedSeats([node]);
    } else if (
      selectedSeats.indexOf(node) === -1 &&
      !selectedSeats.includes('table')
    ) {
      setSelectedSeats(selectedSeats.concat(node));
    } else {
      setSelectedSeats(selectedSeats.filter(x => x !== node));
    }
    if (node === 'table') {
      setSelectedSeats(['table']);
    }
  };

  const print = (reqData, seatId) => {
    let checkData = JSON.parse(window.sessionStorage.getItem('seat'));
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      storeId: props.deviceInfo.storeId,
      checkHeaderId: checkData.id,
      seatIds: seatId,
    };
    props
      .printing(dataToSend)
      .then(res => {
        if (window.ReactNativeWebView) {
          EventEmitter.print(res);
        }
        props.setPrintNotification(res);
        setPrintModel(false);
        setSelectedSeats([]);
      })
      .catch(e => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const toolsItems = [
    {
      id: 1,
      key: 'syncCheck',
      visible: true,
      displayName: LABEL().SYNC_CHECKS_WITH_POS,
    },
    {
      id: 2,
      key: 'print',
      visible: true,
      displayName: LABEL().PRINT,
    },
    {
      id: 3,
      key: 'repostPayment',
      visible: true,
      displayName: LABEL().REPOST_PAYMENT,
    },
    {
      id: 4,
      key: 'pay',
      visible: !isLandScape && true,
      img: dollar,
    },
  ];

  const sortColumn = key => {
    if (sortBy === SORT_ASC) {
      setSortKey(key);
      setChecks(tableOperation.sortTable(key, checks, SORT_DESC));
      setSortBy(SORT_DESC);
    } else {
      setSortKey(key);
      setChecks(tableOperation.sortTable(key, checks, SORT_ASC));
      setSortBy(SORT_ASC);
    }
  };

  const tableHeader = () => {
    return (
      tableHead &&
      tableHead.map(item => {
        return (
          <div
            key={item.key}
            className={cn(
              'col p-0 pr-3',
              !isLandScape ? 'h-52 mt-3' : 'pt-2',
              item.key === 'more' && 'col-1'
            )}
            tabIndex="0"
            role="button"
            onClick={() => sortColumn(item.key)}
          >
            <div
              className={cn(
                'h-100 col-12 p-0 d-flex fw-400 text-capitalize justify-content-between',
                sortKey === item.key && style.selected_filter
              )}
            >
              <span
                className={cn(
                  'od-text-primary fs-16 fw-400 py-0',
                  !isLandScape && 'pr-1 pb-1'
                )}
                style={{ color: serverAppTheme?.secondary_text }}
              >
                {item.name}
              </span>

              <span
                role="presentation"
                className="position-relative float-right "
              >
                {sortKey === item.key && (
                  <div
                    className={cn(
                      sortKey === item.key ? 'od-text-primary' : '',
                      sortKey === item.key && sortBy === 'asc' && style.revert
                    )}
                  >
                    {/* <i className="fas fa-sort-up fa-lg" />a */}
                    <Sorting
                      fill={serverAppTheme?.primary_text}
                      alt="filter"
                      className={cn('mr-1')}
                    />
                  </div>
                )}
              </span>
            </div>
          </div>
        );
      })
    );
  };

  const signOut = () => {
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: props.deviceInfo.deviceId,
      employeeId: getObjectValue(
        () => props.userInfo.id,
        JSON.parse(window.sessionStorage.getItem('userInfo')).id
      ),
      employeeCard: getObjectValue(() => props.userInfo.employeeCard, null),
    };
    props.logout(dataToSend);
    props.history.replace('/checkIn');
  };

  const handleTouchStart = () => {
    signOut();
  };

  const teamId = props.auth?.jobs.find(e => e.id === props.userInfo?.jobId)
    ?.jobTeamId;
  const jobList = props.auth?.jobs.filter(e => e.jobTeamId === teamId);

  const visibilityCheck = (userInfo, check) => {
    if (props.isMyCheck) {
      return userInfo.id === check.employeeId;
    }
    let employeeList = {};
    jobList.forEach(e => {
      if (
        props.employeeJobHashTable[e.id] &&
        props.employeeJobHashTable[e.id].employees[check.employeeId]
      ) {
        employeeList = props.employeeJobHashTable[e.id].employees;
      }
    });
    if (props.auth.employees.find(e => e.id === check.employeeId)) {
      const jobId = props.auth.employees.find(e => e.id === check.employeeId)
        .jobId;
      if (
        props.employeeJobHashTable[jobId] &&
        props.employeeJobHashTable[jobId].checkVisibility === 3
      )
        return true;
    }
    if (!userInfo.jobId) {
      return userInfo.id === check.employeeId;
    }
    if (!props.employeeJobHashTable[userInfo.jobId]) {
      return userInfo.id === check.employeeId;
    }
    switch (props.employeeJobHashTable[userInfo.jobId].checkVisibility) {
      case 0:
        return userInfo.id === check.employeeId;
      case 1:
        return !teamId
          ? Object.keys(
              props.employeeJobHashTable[userInfo.jobId].employees
            ).includes(`${check.employeeId}`)
          : Object.keys(employeeList).includes(`${check.employeeId}`);
      default:
        return true;
    }
  };

  const getUnpaidAmount = table => {
    const discount = getObjectValue(() => table.discountAmount, 0);
    const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
    return props.auth.country === 1
      ? +(
          table.itemAmount +
          table.taxAmount +
          serviceCharge -
          discount -
          table.paidAmount
        )
      : +(table.itemAmount - discount - table.paidAmount);
  };

  const itemsFilter = array => {
    return array
      .filter(
        e =>
          e.pending &&
          !(
            JSON.parse(e.orderJson).modifierJson &&
            JSON.parse(JSON.parse(e.orderJson).modifierJson).isLinked
          )
      )
      .map(e => {
        return {
          ...e,
          ...JSON.parse(e.orderJson),
          menuItemName:
            JSON.parse(e.orderJson).modifierJson &&
            JSON.parse(JSON.parse(e.orderJson).modifierJson).menuItemName
              ? JSON.parse(JSON.parse(e.orderJson).modifierJson).menuItemName
              : JSON.parse(e.orderJson).menuItemName,
        };
      });
  };

  let tableList = [];
  tableList = props.allChecksVisible
    ? props.tableData &&
      Object.values({ ...props.tableData }).reduce((a, v) => {
        const id = props.auth.stations.find(f => v.stationId === f.id)?.name;
        const isZeroChecks = suppressZeroDollarChecks && v.totalAmount === 0;
        if (v.open && !isZeroChecks && visibilityCheck(props.userInfo, v)) {
          a.push({
            ...v,
            stationId:
              v.stationName || v.tabName || id || v.stationNumber || v.name,
            stationName: v.stationName || v.stationNumber || v.name,
            time: v.openDate,
            unpaidAmount: getUnpaidAmount(v).toFixed(2),
            pendingItems: itemsFilter(
              (v.orders && v.orders[0] && v.orders[0]?.items) || []
            ),
          });
        }
        return a;
      }, [])
    : props.tableData &&
      Object.values({ ...props.tableData }).reduce((a, v) => {
        const id = props.auth.stations.find(f => v.stationId === f.id)?.name;
        if (visibilityCheck(props.userInfo, v)) {
          a.push({
            ...v,
            stationId:
              v.stationName || v.tabName || id || v.stationNumber || v.name,
            stationName: v.stationName || v.stationNumber || v.name,
            time: v.openDate,
            unpaidAmount: getUnpaidAmount(v).toFixed(2),
            pendingItems: itemsFilter(
              (v.orders && v.orders[0] && v.orders[0]?.items) || []
            ),
          });
        }
        return a;
      }, []);

  const searchUpdated = value => {
    setSearch(value);
    const key = value;
    const filterData = tableList.filter(item =>
      createFilter(key, headerData, item)
    );
    setChecks(filterData);
    if (key === '' || key === null) {
      setChecks(tableList);
    }
  };

  const openmodel = (e, data) => {
    props.setSeat(data);
    e.stopPropagation();
  };
  const handleClick = item => {
    switch (item.id) {
      case 1:
        syncCheck();
        break;
      case 2:
        printModelPopup();
        break;
      case 4:
        goToDetailsPage();
        break;
      default:
        break;
    }
  };

  // HTML CSS CODE

  return (
    <>
      {props.loading && <Loader />}
      <div
        className={cn('h-100 p-3')}
        style={{ backgroundColor: serverAppTheme?.background_color }}
      >
        {isLandScape ? (
          <div className={cn('align-items-center d-flex w-100 h-8')}>
            <div className="col-8 col-md-8 p-0 m-0 h-100">
              <OptionMenus
                serverAppTheme={props.serverAppTheme}
                isLandScape={isLandScape}
              />
            </div>

            <div className={cn('col-4 col-md-4 h-100 d-flex p-0 pl-2')}>
              <div
                className={
                  isSearch
                    ? 'd-flex col-10 px-0  h-100 align-items-start'
                    : 'd-flex col-9 px-0  h-100 align-items-start'
                }
              >
                {!isSearch && (
                  <div
                    className={cn(style.searchIcon)}
                    style={inLineStyle?.icon}
                  >
                    <SearchDetailsTwo
                      fill={props.serverAppTheme?.iconcolor}
                      aria-hidden="true"
                      onClick={() => {
                        setIsSearch(true);
                        setOpenKeyboard(true);
                      }}
                    />
                  </div>
                )}
                {isSearch && (
                  <Search
                    serverAppTheme={props.serverAppTheme}
                    isSearch={isSearch}
                    onChange={searchUpdated}
                    onClose={() => setIsSearch(false)}
                    setOpenKeyboard={setOpenKeyboard}
                    openKeyboard={openKeyboard}
                    placeholderName={'Search table or check'}
                  />
                )}
              </div>
              <div
                className={cn(
                  isSearch
                    ? 'd-flex col-2 px-0 justify-content-end'
                    : 'd-flex col-3 px-0 justify-content-end'
                )}
              >
                {!isSearch && (
                  <div className={cn(!isLandScape ? 'col-1 px-1' : 'px-1')}>
                    <div
                      className={cn('text-center', style.searchIcon)}
                      style={inLineStyle?.icon}
                      role="presentation"
                    >
                      {' '}
                      <Help
                        fill={serverAppTheme?.iconcolor}
                        aria-hidden="true"
                        style={{ height: '20px' }}
                      />
                    </div>
                  </div>
                )}
                <div className={cn(!isLandScape && 'col-1 pl-1')}>
                  <div
                    className={cn(' fs-30 text-center', style.searchIcon)}
                    style={inLineStyle?.icon}
                    role="presentation"
                    onClick={() => handleTouchStart()}
                  >
                    {/* <img src={signOutIcon} className="od-text-primary" /> */}
                    <SignOutIcon
                      fill={serverAppTheme?.iconcolor}
                      className="od-text-primary"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={cn(
              'align-items-center d-flex w-100',
              !isLandScape && 'm-0 p-0'
            )}
            style={{ height: '4%' }}
          >
            <div className={cn('p-0 m-0 text-left', !isLandScape && 'col-1')}>
              <div className="col-10 text-center p-0 m-0">
                <OptionMenus
                  serverAppTheme={props.serverAppTheme}
                  isLandScape={isLandScape}
                />
              </div>
            </div>

            <div
              className={cn(
                'col-11 h-100 d-flex text-right  justify-content-end',
                !isLandScape ? 'col-md-3 m-0 p-0' : 'ml-auto'
              )}
            >
              <div
                className={cn(
                  isSearch
                    ? isLandScape
                      ? 'col-4'
                      : 'col-11'
                    : isLandScape
                    ? 'col-3 px-1'
                    : 'col-1 px-1',
                  'h-100'
                )}
              >
                {!isSearch && (
                  <div
                    className={cn(style.searchIcon)}
                    style={inLineStyle?.icon}
                  >
                    <SearchDetailsTwo
                      fill={props.serverAppTheme?.iconcolor}
                      aria-hidden="true"
                      onClick={() => setIsSearch(true)}
                      style={{ height: '20px' }}
                    />
                  </div>
                )}
                {isSearch && (
                  <Search
                    serverAppTheme={props.serverAppTheme}
                    isSearch={isSearch}
                    onChange={searchUpdated}
                    onClose={() => setIsSearch(false)}
                    setOpenKeyboard={setOpenKeyboard}
                    openKeyboard={openKeyboard}
                    placeholderName={'Search table or check'}
                  />
                )}
              </div>

              {!isSearch && (
                <div className={cn(!isLandScape ? 'col-1 px-1' : 'px-1')}>
                  <div
                    className={cn('text-center', style.searchIcon)}
                    role="presentation"
                    style={inLineStyle?.icon}
                  >
                    <Help
                      fill={serverAppTheme?.iconcolor}
                      aria-hidden="true"
                      style={{ height: '20px' }}
                    />
                  </div>
                </div>
              )}
              <div className={cn(!isLandScape && 'col-1 pl-1')}>
                <div
                  className={cn(' fs-30 text-center', style.searchIcon)}
                  role="presentation"
                  style={inLineStyle?.icon}
                  onClick={() => handleTouchStart()}
                >
                  <SignOutIcon fill={serverAppTheme?.iconcolor} />
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className={cn(isLandScape ? 'row h-92' : 'h-100')}
          style={{ flexDirection: props.userInfo?.flipView && 'row-reverse' }}
        >
          <div
            id="checksList"
            className={cn(
              isLandScape
                ? 'col-8 col-md-8 position-relative h-100 pr-2'
                : 'p-0 h-100 position-relative'
            )}
          >
            {isLandScape ? (
              <>
                <div className={cn('row mx-0 fs_12 flex-nowrap px-0')}>
                  {tableHeader()}
                </div>
                <hr className={cn(isLandScape && style.horizontal_line_Land)} />{' '}
              </>
            ) : (
              <>
                {' '}
                <div className={cn('row mx-0 fs_12 flex-nowrap h-5 px-0')}>
                  {tableHeader()}
                </div>
                <hr className={cn(style.horizontal_line)} />{' '}
              </>
            )}

            {Object.values(checks).filter(e => e.open).length > 0 ? (
              <div
                className={cn('overflowY h-90', isLandScape && 'p-0 pt-2')}
                style={{ fontSize: '1.6rem' }}
              >
                {Object.values(checks)
                  .filter(e => e.open)
                  .map(e => {
                    const showMoreOption =
                      moreModel && selectedCheck && selectedCheck === e?.id;
                    return (
                      <div
                        key={e.id}
                        role="presentation"
                        onClick={event => {
                          openmodel(event, e);
                        }}
                        className={cn(
                          'col-12 p-0 card border-0 my-1 pr-0 od-container-card-background',
                          style.container_card
                        )}
                        style={inLineStyle?.checkListStyle(showMoreOption)}
                      >
                        <div
                          style={showMoreOption ? { flexBasis: '50%' } : {}}
                          className={cn(
                            'w-100 d-flex p-0 fs-32 align-items-center col-12 p-0 ',
                            showMoreOption ? 'h-50' : 'h-100'
                          )}
                        >
                          <div
                            className="col-11 px-0 h-100 d-flex p-0 fs-32 align-items-center"
                            tabIndex="0"
                            role="button"
                            onClick={() => navigateToPaymentScreen(e)}
                          >
                            <div
                              className={cn(
                                'col d-flex flex-column px-0 od-text-primary text-left fs_16 fw-500'
                              )}
                            >
                              {e?.stationName?.trim() !== '' ? (
                                <div
                                  className={cn(
                                    'border text-center rounded ml-2',
                                  'fs_16'
                                  )}
                                  style={{
                                    height: '80%',
                                    width: isLandScape ? '68%' : '78%',
                                    background: serverAppTheme?.seat_bg,
                                    color: serverAppTheme?.seat_box_text,
                                    paddingBottom: '0.15rem',
                                  }}
                                >
                                  {' '}
                                  {e?.stationName?.length > 3
                                    ? `${e?.stationName?.slice(0, 3)}...`
                                    : e?.stationName}
                                </div>
                              ) : (
                                ''
                              )}
                            </div>

                            <div className="col d-flex flex-column px-0 od-text-primary text-left fs_16 fw-500">
                              {e.number}
                            </div>

                            <div className="col d-flex flex-column px-0 od-text-primary text-left fs_16 fw-500">
                              {' '}
                              {LABEL().CURRENCY_SYMBOL}
                              {Number(e.paidAmount).toFixed(2)}
                            </div>

                            <div className="col d-flex flex-column px-0 od-text-primary text-left fs_16 fw-500">
                              {LABEL().CURRENCY_SYMBOL}
                              {Number(e.unpaidAmount).toFixed(2)}
                            </div>

                            <div className="col d-flex flex-column px-0 od-text-primary text-left fs_16 fw-500">
                              {LABEL().CURRENCY_SYMBOL}
                              {Number(e?.totalAmount).toFixed(2)}
                            </div>
                          </div>
                          <div className="col-1 border-0 d-flex flex-column px-0 od-text-primary h-100">
                            <button
                              className={cn(
                                'h-100 col-12 px-0  d-flex justify-content-center align-items-center',
                                !showMoreOption
                                  ? style.more_btn
                                  : style.more_btn_two,
                                isLandScape && style.more_btn_Land
                              )}
                              style={inLineStyle?.moreButton(showMoreOption)}
                              onClick={() => {
                                setMoreModel(!moreModel);
                                setSelectedCheck(e.id);
                              }}
                            >
                              <MoreInfo fill={serverAppTheme?.primary_text} />
                            </button>
                          </div>
                        </div>

                        {showMoreOption && (
                          <div
                            className="w-100 row mx-0 p-0 py-1"
                            style={inLineStyle?.moreButParent}
                          >
                            {toolsItems &&
                              toolsItems.map((item, i) => {
                                return (
                                  item.visible && (
                                    <div
                                      key={item.id}
                                      className={cn(
                                        ' d-flex h-100 align-items-center justify-content-center',
                                        item.key !== 'pay' && 'col',
                                        i === 0 ? 'px-1' : 'pl-0 pr-1'
                                      )}
                                      style={{
                                        width:
                                          item.key === 'pay' &&
                                          !isLandScape &&
                                          '14%',
                                      }}
                                    >
                                      <button
                                        type="button"
                                        className={cn(
                                          'px-0 rounded od-btn-primary color-white btn-ripple border-0 fs-14 fw-400 w-100',
                                          style.primary_btn,
                                          style.menu_btn
                                        )}
                                        style={inLineStyle?.moreButOpen(item)}
                                        onClick={() => handleClick(item)}
                                        disabled={item.id === 3}
                                      >
                                        {item.img ? (
                                          <img
                                            src={item.img}
                                            alt="itemDisplayName"
                                          />
                                        ) : (
                                          item.displayName
                                        )}
                                      </button>
                                    </div>
                                  )
                                );
                              })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                <div>
                  <Modal isModalCenter>
                    <div className="col-12 px-0 py-1 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
                      <div className="col-12 p-0 fs-30 fw-600 position-relative">
                        More
                        <div
                          className="fs-18 position-absolute"
                          style={{
                            top: '0',
                            right: '5px',
                          }}
                        >
                          <i
                            role="presentation"
                            onClick={() => setMoreModel(false)}
                            className="fa fa-times fs-24"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="col-12 mx-0 p-0 justify-content-center">
                          {toolsItems &&
                            toolsItems.map(item => {
                              return (
                                item.visible && (
                                  <div key={item.id} className="col-12 p-1">
                                    <button
                                      type="button"
                                      className={cn(
                                        'btn rounded od-btn-primary color-white btn-primary btn-ripple btn35 w-100'
                                      )}
                                      onClick={() => handleClick(item)}
                                      disabled={item.id === 3}
                                    >
                                      {item.displayName}
                                    </button>
                                  </div>
                                )
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            ) : (
              <div
                className={cn(
                  'justify-content-center align-items-center od-text-primary fs-22 fw-400',
                  isLandScape ? 'h-85 d-flex' : 'row h-100',
                  style.noCheck
                )}
              >
                {LABEL().NO_CHECKS}
              </div>
            )}
          </div>
          <div className="col-4 pl-0 pt-2 h-100">
            {isLandScape && (
              <div className="h-100">
                <PaymentTerminall
                  checksLength={Object.values(checks).length}
                  {...props}
                  toToStage={toToStage}
                  navigateToPaymentScreen={navigateToPaymentScreen}
                  checkListLength={Object.values(checks).length}
                  isLandScape={isLandScape}
                  viewDetailsPopup={viewDetailsPopup}
                  viewDetails={viewDetails}
                  viewDetailsOnClose={viewDetailsOnClose}
                  serverAppTheme={props.serverAppTheme}
                />
                {
                  <Modal
                    isOpen={payLoading}
                    isModalCenter
                    style={{
                      margin: '',
                      background: serverAppTheme.popUp_bg,
                      border: serverAppTheme?.popupBorder,
                      borderRadius: '16px',
                      boxShadow: serverAppTheme?.popUp_box_shadow,
                    }}
                  >
                    <div
                      className="col-12 px-0 py-1 justify-content-center align-items-center position-relative text-center od-text-primary"
                      style={{ color: serverAppTheme.primary_text }}
                    >
                      <div className="fs-18 h-8 text-right px-2">
                        {/* <img src={cross} style={{width:'28px',height:'28px'}} /> */}
                        <Cross fill={serverAppTheme?.iconcolor} />
                      </div>
                      <div className="fs-18">{payLoadingData}</div>
                      <i
                        className="fa fa-spinner"
                        style={{ fontSize: '48px', color: 'white' }}
                      />
                    </div>
                  </Modal>
                }
                {
                  <Modal isOpen={errorpayLoading} isModalCenter>
                    <div className="col-12 px-0 py-1 justify-content-center align-items-center position-relative text-center od-text-primary">
                      <div className="fs-18 h-8 text-right px-2">
                        <i
                          role="presentation"
                          onClick={() => {
                            setPayLoading(false);
                            setErrorpayLoading(false);
                          }}
                          className="fa fa-times fs-24"
                          aria-hidden="true"
                        />
                        <div className="text-center">
                          <h4>Error Connecting to card reader</h4>
                          <img
                            src={Alert}
                            style={{ width: '104px' }}
                            alt="Alert"
                          />
                          <div className="col-12 row pl-5 pr-5 pt-3 pb-3">
                            <h6>
                              Unable to connect to card reader. Please click
                              retry to try again. You may have to restart
                              OneDine or Reboot the tablet to connect
                            </h6>
                          </div>
                        </div>
                        <div className="row col-12 pb-3">
                          <div className="col-6 text-center">
                            <button
                              className="btn text-center btn20 btn btn-primary btn-ripple od-btn-primary w-100"
                              onClick={() => {
                                setErrorpayLoading(false);
                                payRoute(
                                  payRetryData.data,
                                  payRetryData.currentPage
                                );
                              }}
                            >
                              Retry
                            </button>
                          </div>
                          <div className="col-6 text-center">
                            <button
                              className="btn text-center btn20 btn btn-primary btn-ripple od-btn-primary w-100"
                              onClick={() => {
                                setPayLoading(false);
                                setErrorpayLoading(false);
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                }
              </div>
            )}
            <FullWithModal
              isOpen={printModel}
              isModalCenter
              customClass2={cn('w-100 h-100 p-3')}
              noBackground
              style={inLineStyle?.tablePopUp}
            >
              <div className="col-12 mt-2 p-0 justify-content-center align-items-center position-relative text-center w-100 h-100 text-white">
                <div
                  className="col-12 p-0 position-absolute text-right"
                  style={{ right: '10px', zIndex: '999', fontSize: '18px' }}
                  role="presentation"
                  onClick={onCloseModel}
                >
                  <Cross fill={serverAppTheme?.iconcolor} />
                </div>
                <div
                  className="col-12 text-center fw-700 od-text-primary mt-1"
                  style={{
                    fontSize: '18px',
                    color: serverAppTheme?.primary_text,
                  }}
                >
                  {LABEL().PAY_PRINT_RECEIPT}{' '}
                </div>
                <div
                  className={cn(
                    'flex-column fs_12 justify-content-center',
                    isLandScape ? 'h-78' : 'mt-4 h-84 px-3'
                  )}
                  style={{
                    alignItems: 'baseline',
                    padding: isLandScape && '28px 60px 0px',
                  }}
                >
                  <div
                    className={cn(
                      'd-flex align-self-left row mx-0',
                      isLandScape ? 'mb-2' : 'mb-2'
                    )}
                  >
                    <div
                      role="presentation"
                      className={cn(
                        selectedSeats.includes('table')
                          ? style.selected_cartType
                          : style.tabletilebackground,
                        style.border_btn,
                        'rounded color-white px-3 py-1 text-center fs_18 d-flex justify-content-center align-items-center'
                      )}
                      onClick={() => addRemoveSeats('table')}
                      style={inLineStyle?.selectedSeatsStyle}
                    >
                      {LABEL().TABLE}
                    </div>
                  </div>
                  <div
                    className={cn(
                      isLandScape ? style.wrapperLand : style.wrapper,
                      'overflowY align-items-center w-100'
                    )}
                  >
                    {seats &&
                      seats.length > 0 &&
                      seats.map(e => {
                        return (
                          e.open && (
                            <div
                              role="presentation"
                              className={cn(
                                'fs_18 p-0 d-flex justify-content-center align-items-center',
                                selectedSeats.includes(e.id)
                                  ? style.selected_cartType
                                  : style.unselected,
                                style.border_btn,
                                'btn-ripple rounded text-center fs_18 color-white'
                              )}
                              onClick={() => addRemoveSeats(e.id)}
                              style={inLineStyle?.unSelectedSeatsStyle(e)}
                            >
                              {e.number}
                              {e.name ? (
                                <span>
                                  (
                                  <span className={style.truncate}>
                                    {' '}
                                    {e?.name}
                                  </span>
                                  )
                                </span>
                              ) : (
                                ''
                              )}
                            </div>
                          )
                        );
                      })}
                  </div>
                </div>
                <div
                  className={cn(
                    'col-12 row mx-0 justify-content-center align-items-center position-relative text-center od-text-primary text-white w-100 pb-3',
                    !isLandScape && 'px-3 p-0 mt-3'
                  )}
                  style={{ padding: isLandScape && '4px 60px 0px' }}
                >
                  <div className="col-6 pl-0 pr-1">
                    <button
                      className={cn(
                        style.btnSecondarytPrint,
                        'btn44 fw-600',
                        'col-12 p-0'
                      )}
                      type="button"
                      onClick={onCloseModel}
                      style={inLineStyle?.cancelButton}
                    >
                      {LABEL().CANCEL}
                    </button>
                  </div>
                  <div className="col-6 pl-0 pr-1">
                    <button
                      className={cn(
                        selectedSeats.length === 0
                          ? style.btnDisabled
                          : style.btnPrimaryPrint,
                        'btn44 fw-600',
                        'col-12 p-0'
                      )}
                      type="button"
                      onClick={() => {
                        print(
                          seats,
                          selectedSeats.includes('table') ? [] : selectedSeats
                        );
                      }}
                      disabled={selectedSeats.length === 0}
                      style={inLineStyle?.printButton}
                    >
                      {LABEL().PRINT}
                    </button>
                  </div>
                </div>
              </div>
            </FullWithModal>

            <Modal
              isOpen={props.isPrintOpen}
              isModalCenter
              noBackground
              customClass2={'px-3'}
              style={inLineStyle.modalStyle}
            >
              <div
                className="col-12 my-4 fs-16 justify-content-center align-items-center position-relative text-center od-text-primary text-white"
                style={inLineStyle?.parentContainerColor}
              >
                <div>
                  <br />
                  <br />
                  <div className="text-left" style={inLineStyle?.printerName}>
                    Printer Name: {props.printData?.printerName}
                  </div>
                  <br /> <br />
                </div>
                <div
                  className={cn(style.imgSpin, 'od-spinner position-absolute')}
                />
                {/* <br /><br /> */}
              </div>
            </Modal>
          </div>
        </div>
        {props.isEmployeeCheck && (
          <EmployeeCheck
            {...props}
            caseType={flowType()}
            callBack={() => signOut()}
          />
        )}
      </div>
    </>
  );
};

// Redux Part

const mapStateToProps = state => ({
  tableData: state.storeChecks.checkListHashTable,
  loading: state.storeChecks.loading,
  auth: state.oauth.authInfo,
  userInfo: state.oauth.loggedInUserData,
  employeeJobHashTable: state.oauth.employeeJobHashTable,
  deviceInfo: state.oauth.deviceInformation,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
  allChecksVisible: state.optionsMenus.allChecksVisible,
  isMyCheck: state.storeChecks.isOn,
  isPrintOpen: state.notification.isPrintOpen,
  printData: state.notification.printData,
  check: state.orders.seats,
  serverAppTheme: state.theme.serverAppTheme,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSeat,
      printing,
      setPrintNotification,
      setNotification,
      syncCheck,
      logout,
      openEmployeeCheck,
      setInActivityStatus,
      setPaymentCheck,
      syncCheckForPayment,
      setErrorPopUp,
      toggleTheme,
      syncForPayment,
      setSyncData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentTerminal);
